import { useContext, useEffect, useState } from "react";
import { RouteContext } from "../../contexts/RoutesContext";
import { AppContext } from "../../contexts/AppContext";
import { API_GetIntranetQuickApply, IntranetPositionDetailsModel } from "../../apis/ApisPositions";
import { useSearchParams } from "react-router-dom";
import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { Colour } from "../Variables";
import { InternalApplicationApplyForm } from "../components/Forms/InternalApplicationApplyForm";

export function IntranetQuickApply() {
    const app = useContext(AppContext);
    const routeContext = useContext(RouteContext);
    const [queryParameters] = useSearchParams();
    const [positionDetails, setPositionDetails] = useState<IntranetPositionDetailsModel>(null);

    let id = queryParameters.get("id");
    
    useEffect(() => {
        routeContext.setRoutes([{ name: "Intranet positions", route: "/Intranet" }, { name: "Intranet apply", route: null }])
    }, []);

    useEffect(() => {
        async function asyncCall() {
            var position = await API_GetIntranetQuickApply(id, app.token);
            setPositionDetails(position);
        }

        if (!app.loading) {
            asyncCall();
        }
    }, [app.loading]);

    return (
        <>
            <InfoBanner
                header="Internal application"
                narrow={true}
                icon={InfoHeaderIcon.Positions}
                info={``}
                subHeader={positionDetails?.PositionName}
                theme={Colour.Alt}>
            </InfoBanner>

            <InternalApplicationApplyForm baseState={positionDetails} id={id} />
        </>
    );
}